export const SITE = "dawgs";
export const HOME_TEAMS = ["dawgs"];
export const MAIN_COLOR = "#EC1F27";
export const BACKUP_LOGO_URL = "/img/dawgs.png";

export const ticketLinks = [
  { label: "Single Game Tickets", url: "/tickets/single-game" },
  { label: "Season Tickets", url: "/tickets/season-tickets" },
  { label: "Group & Patio Bookings", url: "/tickets/group-bookings" },
  { label: "Legacy Seats", url: "/tickets/legacy-seats" },
  {
    label: "WCBL All Star Game",
    url: "https://tickets.dawgsbaseball.ca/events/28348-2024-wcbl-all-star-game",
    external: true,
  },
];

export const getTeamLinks = (rosterPagePath) => [
  {
    label: "Roster & Coaching Staff",
    url: rosterPagePath,
  },
  { label: "Front Office", url: "/front-office" },
  {
    label: "Statistics",
    url: "http://baseball.pointstreak.com/team_stats.html?teamid=155849&seasonid=33280",
    external: true,
  },
  { label: "News", url: "/news" },
  { label: "History", url: "/history" },
  { label: "Hall Of Fame", url: "/hall-of-fame" },
  { label: "Dawgs MLB Draft Picks", url: "/dawgs-mlb-draft-picks" },
  { label: "Player Application", url: "/player-application" },
  { label: "Become A Host Family", url: "/become-a-host-family" },
  { label: "Dawgs Baseball Camp", url: "/dawgs-baseball-camp" },
  { label: "Dawgs 50/50", url: "/dawgs-50-50" },
  {
    label: "Diggity And Player Appearances",
    url: "/diggity-and-player-appearances",
  },
  {
    label: "Volunteer At The Ballpark",
    url: "/volunteer-at-the-ballpark",
  },
];
export const facilityLinks = [
  { label: "Seaman Stadium", url: "/facilities/seaman-stadium" },
  { label: "Kore 4 (+14) Corner", url: "/facilities/kore-4-14-corner" },
  {
    label: "Ircandia Outdoor Training Centre",
    url: "/facilities/ircandia-outdoor-training-centre",
  },
  { label: "Duvernay Fieldhouse", url: "/facilities/duvernay-fieldhouse" },
  { label: "Tourmaline Field", url: "/facilities/tourmaline-field" },
  { label: "Conrad Field", url: "/facilities/conrad-field" },
];

export const fanExperienceLinks = [
  {
    label: "Food and Beverage menu",
    url: "/fan-experience/food-and-beverage-menu",
  },
  {
    label: "Rules of the ballpark",
    url: "/fan-experience/rules-of-the-ballpark",
  },
  {
    label: "Stadium Map",
    url: "/fan-experience/stadium-map",
  },
  {
    label: "FAQ",
    url: "/fan-experience/FAQ",
  },
  {
    label: "Distance/Directions",
    url: "/fan-experience/distance-directions",
  },
  {
    label: "Promo Schedule",
    url: "/fan-experience/promo-schedule",
  },
];

export const socialMediaData = {
  instagram: "https://www.instagram.com/okotoksdawgs/",
  twitter: "https://x.com/Okotoks_Dawgs",
  facebook: "https://www.facebook.com/OkotoksDawgs/",
  tiktok: "https://www.tiktok.com/@okotoksdawgs",
  youtube: "https://www.youtube.com/channel/UCq_zEHvZ9Z2kFkSB7zbhZlA/featured",
};

export const timelineAccount = "Okotoks_Dawgs";
